export default function _setCameraApi(camera) {
  setProperties.bind(this)(camera);
  camera.useVR = options => {
    if (!options.VRObject?.isObject3D) return;
    const VROptions = {VRCamera: camera, ...options};
    this.context.setVRSession(VROptions);
  };

  camera.activate = () => {
    this.context.scenePlayCameras.forEach(cam => {
      if (cam.uuid === camera.uuid) {
        cam.enabled = true;
      } else cam.enabled = false;
    });
  };

  camera.useFPS = () => {
    this.context.changeShootingMode("FPS_MODE");
  };

  camera.useTPV = (mode = "NORMAL_MODE", setting) => {
    this.context.changeShootingMode(mode, setting);
  };
}

function setProperties(camera) {
  const {enabled, depth} = camera.userData;
  const context = this.context;

  Object.defineProperties(camera, {
    enabled: {value: enabled, writable: true},
    _depth: {value: depth, writable: true},
    depth: {
      get() {
        return this._depth;
      },
      set(value) {
        this._depth = value;
        context.updateCameraOrder();
      },
    },
  });
}
